import api from "services/api";
import config from "config";
import { gettoken } from "./gettabconfig";

export const getNotificacao = async () =>{
    const isLogged = gettoken();
    if (!isLogged) {
        return 0;
    }   
    try {
        const response = await api.get(`${config.USUARIOS}/notificacao`);
        // console.log(Number.isInteger(response.data.length) ? response.data.length : 0)
        return Number.isInteger(response.data.length) ? response.data.length : 0;

    } catch (error) {
        console.error('Error fetching notifications:', error);
        return 0;
    }    
}